module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('label', [_vm._v("Location")]), _c('span', {
    staticClass: "has-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('GmapAutocomplete', {
    ref: "autocomplete",
    staticClass: "locationInput",
    attrs: {
      "name": "autocomplete",
      "position": _vm.markers.position
    },
    on: {
      "update:position": function($event) {
        _vm.$set(_vm.markers, "position", $event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.usePlace($event)
      },
      "place_changed": _vm.setPlace
    },
    nativeOn: {
      "input": function($event) {
        return _vm.handleChange($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.isPlace) ? _c('div', {
    staticClass: "has-danger"
  }, [_vm._v("\n            Location is a required field\n          ")]) : _vm._e(), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "50%",
      "height": "200px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 7,
      "map-type-id": "terrain"
    }
  }, [_c('gmap-marker', {
    key: _vm.index,
    attrs: {
      "position": _vm.markers.position,
      "clickable": true,
      "draggable": true
    },
    on: {
      "dragend": _vm.updateMaker,
      "click": _vm.panToMarker
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fcba602a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcba602a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/location.vue
// module id = 2396
// module chunks = 0